module.exports = __webpack_public_path__ + "img/policy-detail.c076a357.png";